import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import './ImportVeiculoMassa.css'
import { PageHeader, Btn, TextBtn, ImportExcelFile, CustomCheckbox } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveVehiclesMassively } from '../../../../services/api/https/system/system.http'
import ExcelModeloBuilderMultiSheet from '../../../../components/ExcelModeloBuilderMultiSheet/ExcelModeloBuilderMultiSheet'
import { CARROCERIAS, RODADOS } from '../../Cadastros/Veiculo/VeiculoModal'

const ImportVeiculoMassa = ({ selectedTp, history, dispatch }) => {
  const modeloExcel = [
    [
      'nome (string)*',
      'placa (string)*',
      'ano_fabricacao (int)',
      'modelo (string)*',
      'capacidade_kg (int)*',
      'capacidade_m3 (int)',
      'cnh_motorista_padrao (int)*',
      'km_inicial (int)',
      'proprio (0,1)*',
      'transportadora_cnpj (string)',
      'ativo (0,1)*',
      'tipo_carroceria (int)',
      'tipo_rodado (int)',
    ],
  ]

  const valoresCarrocerias = [
    ['Valor', 'Descrição'],
    ...CARROCERIAS.map(carroceria => [carroceria.value, carroceria.label]),
  ]
  const valoresRodados = [
    ['Valor', 'Descrição'],
    ...RODADOS.map(rodado => [rodado.value, rodado.label]),
  ]

  const modelos = [
    {
      wsName: 'Modelo',
      colunas: modeloExcel,
    },
    { wsName: 'Carrocerias', colunas: valoresCarrocerias },
    { wsName: 'Rodados', colunas: valoresRodados },
  ]

  const [veiculos, setVeiculos] = useState([])

  const onBtnSalvarClicked = async () => {
    dispatch(showLoadingBox('Aguarde...', 'Carregando...'))
    try {
      if (selectedTp === '') {
        throw new Error('Selecione um TP')
      }
      if (veiculos.length === 0) {
        throw new Error('Não existem Veiculos para Importação')
      }
      const message = await saveVehiclesMassively(veiculos)
      dispatch(showMessageBox(message, null))
      setVeiculos([])
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onBtnVoltarClicked = () => {
    history.goBack()
  }

  // Função auxiliar para normalizar valores numéricos (aceita vírgula e ponto)
  const _normalizeNumber = value => {
    if (value === null || value === undefined || value === '') {
      return null
    }

    const stringValue = String(value).replace(',', '.')
    const numericValue = parseFloat(stringValue)

    return isNaN(numericValue) ? null : numericValue
  }

  const _normalizeString = value => {
    if (value === null || value === undefined) {
      return ''
    }
    return String(value).trim()
  }

  const _planilhaNoPadrao = content => {
    const header = content[0]
    return (
      header[0] === 'nome (string)*' &&
      header[1] === 'placa (string)*' &&
      header[2] === 'ano_fabricacao (int)' &&
      header[3] === 'modelo (string)*' &&
      header[4] === 'capacidade_kg (int)*' &&
      header[5] === 'capacidade_m3 (int)' &&
      header[6] === 'cnh_motorista_padrao (int)*' &&
      header[7] === 'km_inicial (int)' &&
      header[8] === 'proprio (0,1)*' &&
      header[9] === 'transportadora_cnpj (string)' &&
      header[10] === 'ativo (0,1)*' &&
      header[11] === 'tipo_carroceria (int)' &&
      header[12] === 'tipo_rodado (int)'
    )
  }

  const _buildVeiculos = content => {
    const body = content.slice(1)
    const result = []
    for (let index = 0; index < body.length; index++) {
      const row = body[index]
      if (!row[0] || _normalizeString(row[0]) === '') {
        break
      }
      if (
        !row[0] ||
        !row[1] ||
        !row[3] ||
        !row[4] ||
        !row[6] ||
        (row[8] !== 0 && row[8] !== 1) ||
        (row[10] !== 0 && row[10] !== 1)
      ) {
        throw new Error(`Erro próximo a linha ${index + 2} da planilha. Conteúdo inconsistente.`)
      }

      result.push({
        tp_id: selectedTp,
        nickname: _normalizeString(row[0]),
        vehicle_badge: _normalizeString(row[1]),
        year: _normalizeNumber(row[2]),
        manufacturer: _normalizeString(row[3]),
        capacity_kg: _normalizeNumber(row[4]),
        capacity_m3: _normalizeNumber(row[5]),
        default_driver: row[6],
        initial_km: _normalizeNumber(row[7]),
        category: row[8] === 0 ? 'Spot' : 'Proprio',
        transportadora: _normalizeString(row[9]),
        actived: row[10],
        tipo_carroceria: row[11],
        tipo_rodado: row[12],
      })
    }
    return result
  }

  const onFileImported = content => {
    try {
      const isPlanilhaNoPadrao = _planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      setVeiculos(_buildVeiculos(content))
    } catch (error) {
      dispatch(showMessageBox(null, error.message))
    }
  }

  useEffect(() => {
    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione um TP'))
    } else if (veiculos.length > 0) {
      setVeiculos(prevState => {
        return prevState.map(veiculo => {
          return { ...veiculo, tp_id: selectedTp }
        })
      })
    }
  }, [selectedTp])

  return (
    <div>
      <PageHeader>
        <span>S.22 - Importação de Veículos em Massa</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel>
          <div className="p-grid">
            <div className="p-col-9" style={{ paddingTop: 35 }}>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ExcelModeloBuilderMultiSheet
                  modelos={modelos}
                  filename="ImportacaoVeiculos.xlsx"
                />
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ImportExcelFile
                  label="Importar"
                  classes="btnImportar"
                  onFileImported={onFileImported}
                />
              </div>

              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <Btn onClick={onBtnSalvarClicked} disabled={!selectedTp}>
                  Salvar
                </Btn>
              </div>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <TextBtn onClick={onBtnVoltarClicked}>Voltar</TextBtn>
              </div>
            </div>
          </div>
          <div>
            <DataTable value={veiculos}>
              <Column field="nickname" header="Descrição" />
              <Column field="vehicle_badge" header="Placa" style={tableCellCentered(130)} />
              <Column field="year" header="Ano" style={tableCellCentered(150)} />
              <Column field="capacity_kg" header="Capacidade - KG" style={tableCellCentered(150)} />
              <Column field="capacity_m3" header="Capacidade - M³" style={tableCellCentered(150)} />
              <Column
                field="category"
                header="Tipo"
                style={tableCellCentered()}
                body={veiculo =>
                  veiculo.category && veiculo.category === 'Proprio' ? (
                    <span>Próprio</span>
                  ) : (
                    <span>Terceiro</span>
                  )
                }
              />

              <Column field="tipo_carroceria" header="Tipo de Carroceria" />
              <Column field="tipo_rodado" header="Tipo de Rodado" />
              <Column
                field="actived"
                header="Ativo"
                style={tableCellCentered(80)}
                body={veiculo => <CustomCheckbox onChange={() => {}} checked={!!veiculo.actived} />}
              />
            </DataTable>
          </div>
        </Panel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ImportVeiculoMassa))
